import React, { Component } from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import MKIDatatable from '../../../../modules/mki-datatable/lib';
import { config } from '../../../../helpers/config_global';
import IndexBloc from './../Blocs/IndexBloc';
import { cancelToken } from '../../../../services/adapters/kepegawaian/dashboardService';
import apiResponse from '../../../../services/apiResponse';

class PresensiLateComponent extends Component {
  constructor(props) {
    super(props);
    this.indexBloc = new IndexBloc();
    this.source = null;
    this.historyTable = 'historyPresensiLate';
    this.defaultOrder = 'tanggal';
    this.defaultSize = 5;
    this.defaultSort = 'desc';
    this.configDatatable = {
      ...config('datatable'),
      sort: {
        column: this.defaultOrder,
        order: this.defaultSort,
      },
    };
    this.state = {
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: '',
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }

  componentDidMount() {
    this.setTokenAPI();
    this.subscribeToChannel();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.workUnit !== this.props.workUnit ||
      prevProps.filterDate !== this.props.filterDate
    ) {
      this.setTokenAPI();
    }
  }

  componentWillUnmount() {
    this.unsubscribeFromChannel();
  }

  subscribeToChannel = () => {
    this.indexBloc.presensiLateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            console.log(response);
            let total = result.data.response.count;
            this.setState({
              rows: response,
              loadingTable: false,
              totalRow: total,
            });
          }
          break;
        case apiResponse.ERROR:
          this.setState({ loadingTable: false });
          // Handle error
          break;
        default:
          break;
      }
    });
  };

  unsubscribeFromChannel = () => {
    this.indexBloc.presensiLateChannel?.unsubscribe();
  };

  loadData = async () => {
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }

    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      work_unit: this.props.workUnit,
      date: this.props.filterDate,
    };
    this.setState({ loadingTable: true });
    await this.indexBloc.fetchPresensiLate(query, this.source.token);
  };

  setTokenAPI = () => {
    if (this.source) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  columns = [
    {
      key: 'employee_name',
      text: 'Nama Pegawai',
      sortable: true,
      width: '200',
    },
    {
      key: 'position_name',
      text: 'Jabatan Pegawai',
      sortable: true,
      width: '200',
    },
    {
      key: 'presensi_result_checkin',
      text: 'Jam Masuk',
      sortable: true,
      width: '100',
    },
    {
      key: 'presensi_result_checkout',
      text: 'Jam Pulang',
      sortable: true,
      width: '100',
    },
    {
      key: 'keterangan_absen',
      text: 'Absensi Pegawai',
      sortable: true,
      width: '100',
    },
  ];

  render() {
    return (
      <React.Fragment>
        <Card
          style={{
            borderRadius: '20px',
            boxShadow:
              '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
          }}
          className="overflow-auto"
        >
          <CardBody>
            <CardTitle>Presensi Pegawai</CardTitle>
            <MKIDatatable
              className={this.configDatatable.tableClass}
              config={this.configDatatable}
              records={this.state.rows}
              columns={this.columns}
              dynamic={true}
              minWidth={800}
              total_record={this.state.totalRow}
              initial={this.state.filter}
              onChange={(filter) => {
                this.setState(
                  {
                    loadingTable: true,
                    filter: filter,
                  },
                  () => {
                    this.setTokenAPI();
                  }
                );
              }}
              loading={this.state.loadingTable}
            />
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default PresensiLateComponent;
